<template>
  <fragment>
    <button
      ref="filterButton"
      class="btn top-block__filter"
      @click="showFilter"
    >
      <i class="material-icons">filter_list</i>
      Фильтр
    </button>
    <transition name="fade">
      <form
        v-show="isFilterShown"
        ref="filterForm"
        class="top-block__filter__block"
        @submit.prevent="applyFilters"
      >
        <div class="top-block__filter__block__wrapper">
          <div
            class="top-block__filter__block__wrapper__close"
            @click="hideFilter"
          >
            <button
              type="button"
              class="close"
            >
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="top-block__filter__block__deep mb-2">
            <label for="email">E-mail</label>
            <div class="input-group">
              <input
                id="email"
                v-model.trim="filters.email"
                class="form-control form-control-sm"
                placeholder="Введите email пользователя"
              >
            </div>
          </div>
          <div
            v-if="canSeeUrCode"
            class="top-block__filter__block__deep mb-2"
          >
            <label for="UR">UR</label>
            <div class="input-group">
              <input
                id="UR"
                v-model.trim="filters.URCode"
                class="form-control form-control-sm"
                placeholder="Введите UR-код пользователя"
              >
            </div>
          </div>
          <div
            v-if="canSeeGsdbCode"
            class="top-block__filter__block__deep mb-2"
          >
            <label for="GSDB">GSDB</label>
            <div class="input-group">
              <input
                id="GSDB"
                v-model.trim="filters.GSDBCode"
                class="form-control form-control-sm"
                placeholder="Введите GSDB-код пользователя"
              >
            </div>
          </div>
          <div
            v-if="canSeeCarrierCode"
            class="top-block__filter__block__deep mb-2"
          >
            <label for="carrier">Carrier</label>
            <div class="input-group">
              <input
                id="carrier"
                v-model.trim="filters.Carrier"
                class="form-control form-control-sm"
                placeholder="Введите Carrier пользователя"
              >
            </div>
          </div>
          <div
            v-if="canSeeClaimAgentCode"
            class="top-block__filter__block__deep mb-2"
          >
            <label for="claim-agent">Claim agent</label>
            <div class="input-group">
              <input
                id="claim-agent"
                v-model.trim="filters.ClaimAgent"
                class="form-control form-control-sm"
                placeholder="Введите ClaimAgent пользователя"
              >
            </div>
          </div>
          <div class="top-block__filter__block__deep mb-2">
            <label for="email">Роль</label>
            <div class="input-group">
              <multiselect
                v-model="selectedRoles"
                :options="roleList"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                placeholder="Выберите роль"
                selected-label="Роль добавлена"
                select-label="Добавить роль"
                deselect-label="Убрать роль"
                label="description"
                track-by="description"
              >
                <template slot="noResult">
                  По данному запросу ничего не найдено
                </template>
                <template slot="noOptions">
                  Нет доступных ролей
                </template>
              </multiselect>
            </div>
          </div>
          <div class="top-block__filter__block__deep footer">
            <button
              class="btn btn-secondary-ford-gray"
              type="button"
              @click="resetFilters"
            >
              Сбросить
            </button>
            <button
              class="btn btn-primary-ford-orange"
              type="submit"
            >
              <i class="material-icons">check</i>
              Применить
            </button>
          </div>
        </div>
      </form>
    </transition>
  </fragment>
</template>

<script>
export default {
  name: 'FilterUsers',
  props: {
    roleList: Array,
    canSeeUrCode: Boolean,
    canSeeGsdbCode: Boolean,
    canSeeCarrierCode: Boolean,
    canSeeClaimAgentCode: Boolean,
  },
  data: () => ({
    isFilterShown: false,
    filters: {
      email: '',
      URCode: '',
      GSDBCode: '',
      role: [],
      Carrier: '',
      ClaimAgent: '',
    },
    selectedRoles: [],
  }),
  computed: {
    filtersUserRoles() {
      return this.selectedRoles.map(it => it.name).join(',');
    },
  },
  watch: {
    filtersUserRoles() {
      this.filters.role = this.filtersUserRoles;
    },
  },
  methods: {
    showFilter() {
      this.isFilterShown = true;
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClick);
      }, 0);
    },
    hideFilter() {
      this.isFilterShown = false;
      setTimeout(() => {
        document.removeEventListener('click', this.handleOutsideClick);
      }, 0);
    },
    resetFilters() {
      Object.assign(this.$data, this.$options.data());
      this.$emit('applyFilters', this.filters);
      this.hideFilter();
    },
    applyFilters() {
      this.$emit('applyFilters', this.filters);
      this.hideFilter();
    },
    handleOutsideClick(evt) {
      const { filterForm, filterButton } = this.$refs;
      if (filterForm.contains(evt.target) || (filterButton.contains(evt.target) && !this.isFilterShown)) {
        return;
      }

      this.hideFilter();
    },
  },
};
</script>

<style lang="scss">
#addModal {
  .modal-header {
    padding: 1rem 0;

    i {
      color: var(--ford-gray-shadow);
    }
  }

  .modal-title {
    font-weight: bold;
    color: var(--ford-gray-shadow);
  }

  .modal-content {
    padding: 0 35px 15px;
    border: none;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.21);
  }

  .modal-footer {
    padding: 1rem 0;
    border-top: none;
  }

  .modal-body {
    padding: 1rem 0;

    .form-group:last-of-type {
      margin-top: 20px;
    }
  }
}
</style>
